import { createFileRoute } from '@tanstack/react-router';
import { MorePage } from '@/features/more';

export const Route = createFileRoute('/_auth/o/$orgId/more')({
  component: MorePage,
});
